import React, { useContext, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { collection, addDoc, where, query, getDocs } from "firebase/firestore";
import { db } from './config';
import cryptoRandomString from 'crypto-random-string';
import { Link, useNavigate } from 'react-router-dom';
import { AppContext } from './App'

const LANGUAGE = [
    {
        id: 0, label: "None", value: "-"
    },
    {
        id: 1, label: "Java", value: "java"
    },
    {
        id: 2, label: "C++", value: "cpp"
    },
    {
        id: 3, label: "C", value: "c"
    },
    {
        id: 4, label: "Python", value: "python"
    },
    {
        id: 5, label: "JavaScript", value: "javascript"
    },
    {
        id: 6, label: "TypeScript", value: "typescript"
    },
    {
        id: 7, label: "Kotlin", value: "kotlin"
    },
    {
        id: 8, label: "Other", value: "other"
    }
]

export const Paste = () => {
    const [data, setData] = useState('')
    const navigate = useNavigate()
    const context = useContext(AppContext)
    const [id, setId] = useState('')
    const [password, setPassword] = useState('')
    const [diable, setDisable] = useState(false)
    const [lang, setlang] = useState('-')
    const newPaste = async () => {
        const toastId = toast.loading('Creating...', {
            style: {
                fontSize: '11.75px',
                fontFamily: 'Poppins'
            },
        });
        if (diable) return
        if (!data) {
            toast.dismiss(toastId);
            return toast.error('You cannot create an empty paste.', {
                duration: 4000,
                style: {
                    fontSize: '11.75px',
                    fontFamily: 'Poppins'
                },
            });
        }
        setDisable(true)
        const pasteRef = collection(db, "paste");
        const q = query(pasteRef, where("id", "==", id));
        let found = false;
        async function get() {
            try {
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                    const resp = doc.data();
                    if (resp.id === id) {
                        found = true
                    }
                });
                if (found) {
                    setDisable(false)
                    toast.dismiss(toastId);
                    return toast.error(`You cannot create a paste with "${id}".`, {
                        duration: 4000,
                        style: {
                            fontSize: '11.75px',
                            fontFamily: 'Poppins'
                        },
                    });
                }

                const newId = cryptoRandomString({ length: 6 })
                const userExist = context.auth
                const docRef = await addDoc(collection(db, "paste"), {
                    data: data,
                    dislike: 0,
                    id: id ? id : newId,
                    like: 0,
                    password: password ? password : null,
                    protected: password !== '',
                    timestamp: new Date().toString(),
                    uid: userExist ? userExist.uid : null,
                    username: userExist ? userExist.username : `guest${cryptoRandomString({ length: 5 })}`,
                    views: 0,
                    language: lang
                });
                setDisable(false)
                if (docRef.id) {
                    toast.dismiss(toastId);
                    navigate(`/${id ? id : newId}`)
                }
            } catch (err) {
                console.debug(err)
            }
        }
        get()

    }
    return (
        <div className='pastepage' >
            <Toaster />
            <p style={{ marginBottom: '9px', fontSize: '12.5px', fontWeight: 'bold', color: '#ddd', letterSpacing: '0.68px', fontFamily: 'Poppins' }}>New Paste</p>
            <textarea value={data} onChange={e => setData(e.target.value)} placeholder='Paste Something' spellCheck={false}></textarea>
            <p style={{ marginBottom: '9px', fontSize: '12.5px', fontWeight: 'bold', color: '#ddd', letterSpacing: '0.68px', marginTop: '19px' }}>Optional Paste Settings</p>
            <div className="optional-box" style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid rgb(52 52 52)', paddingTop: '15px', height: '325px', marginBottom: '15px' }}>
                <div className="left" style={{ width: '50%', borderRight: '1px solid rgb(52 52 52)' }}>
                    <table style={{ gap: '9px', width: '80%' }}>
                        <tbody>
                            <tr>
                                <td><label htmlFor="password" style={{ fontSize: '11.5px' }}>Password:</label></td>
                                <td> <input value={password} onChange={e => setPassword(e.target.value)} placeholder='Enter Password' style={{ width: '100%' }} id="password" type="text" /></td>
                            </tr>
                            <tr>
                                <td> <label htmlFor="dencode" style={{ fontSize: '11.5px' }}>Paste Name / Title:</label></td>
                                <td> <input value={id} onChange={e => setId(e.target.value)} placeholder='Not Recommended' style={{ width: '100%' }} id="dencode" type="text" /></td>
                            </tr>
                            <tr>
                                <td> <label htmlFor="sel" style={{ fontSize: '11.5px' }}>Code Language:</label></td>
                                <td>
                                    <select id="sel" value={lang} onChange={e => setlang(e.target.value)} className='copy' style={{ fontSize: '11px' }}>
                                        {
                                            LANGUAGE.map(language =>
                                                <option key={language.id} style={{ fontSize: '11px', backgroundColor: '#252525' }} value={language.value}>{language.label}</option>
                                            )
                                        }

                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td> </td>
                                <td><button onClick={() => newPaste()} style={{ color: '#ddd', backgroundColor: 'rgb(56 55 55)', fontFamily: 'Poppins', border: 'none', outline: 'none', cursor: diable ? 'not-allowed' : 'pointer', fontSize: '11.05px', padding: '7px 12px', borderRadius: '2px', marginTop: '10px', }}>Create New Paste</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="right" style={{ width: '50%' }}>
                    <div className="wrapper" style={{ width: '95%', marginLeft: 'auto', paddingTop: '19px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        {
                            context.auth ? <Link to={`/user/${context.auth.username + "=" + context.auth.uid}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                <img src="https://firebasestorage.googleapis.com/v0/b/upload-pics-e599e.appspot.com/o/images%2Fguest.png?alt=media&token=8e691b33-b1ab-451e-b4d2-0257c76daa52" style={{ width: '55px' }} alt="" />
                                <p style={{ fontSize: '12px', marginTop: '9px' }}>Hello , <span style={{}}> {context.auth.username}</span></p>
                            </Link> : <>
                                <img src="https://firebasestorage.googleapis.com/v0/b/upload-pics-e599e.appspot.com/o/images%2Fguest.png?alt=media&token=8e691b33-b1ab-451e-b4d2-0257c76daa52" style={{ width: '55px' }} alt="" />
                                <p style={{ fontSize: '12px', marginTop: '9px' }}>Hello , <span style={{}}>{"Guest - Login or Signup"}</span></p>
                            </>
                        }

                        {
                            !context.auth && (<><div className="sameline" style={{ display: 'flex', flexDirection: 'column', marginTop: '9px' }}>
                                <button onClick={() => navigate('/login')} style={{ width: '250px', color: '#ddd', backgroundColor: 'rgb(56 55 55)', fontFamily: 'Poppins', border: 'none', outline: 'none', cursor: 'pointer', fontSize: '11.75px', padding: '5px 8px', borderRadius: '2px' }}>Login</button>
                                <button onClick={() => navigate('/signup')} style={{ width: '250px', color: '#ddd', backgroundColor: 'rgb(56 55 55)', fontFamily: 'Poppins', border: 'none', outline: 'none', cursor: 'pointer', fontSize: '11.75px', padding: '5px 8px', borderRadius: '2px', marginTop: '14px' }}>Sign Up</button>
                            </div></>)
                        }

                    </div>
                </div>

            </div>
        </div>
    )
}
